import { render } from "./addInfoQy.vue?vue&type=template&id=050829b0"
import script from "./addInfoQy.vue?vue&type=script&lang=js"
export * from "./addInfoQy.vue?vue&type=script&lang=js"

import "./addInfoQy.vue?vue&type=style&index=0&id=050829b0&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__